var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-md-6 col-lg-4 d-flex align-items-center mb-2 mb-md-0",domProps:{"innerHTML":_vm._s(_vm.fieldText)}}),_c('div',{staticClass:"col-md-6 col-lg-8"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }